import { Controller } from "@hotwired/stimulus";

// Toggles visibility of sections matching a CSS selector (e.g. .bg-success-subtle).
// Use data-toggle-sections-selector-value and optional data-toggle-sections-hidden-label-value.
export default class extends Controller {
  static values = {
    selector: { type: String, default: ".bg-success-subtle" },
    hiddenLabel: { type: String, default: "Show accepted requirements" },
    visibleLabel: { type: String, default: "Hide accepted requirements" },
  };

  connect() {
    this.hidden = false;
    this.updateLabel();
  }

  toggle() {
    this.hidden = !this.hidden;
    document.querySelectorAll(this.selectorValue).forEach((el) => {
      el.classList.toggle("d-none", this.hidden);
    });
    this.updateLabel();
  }

  updateLabel() {
    if (this.element.tagName === "BUTTON" || this.element.tagName === "A") {
      this.element.textContent = this.hidden
        ? this.hiddenLabelValue
        : this.visibleLabelValue;
    }
  }
}
